import { useStore } from '../../store/store-provider';
import { observer } from 'mobx-react';
import { getDefaultRouteRedirectPath } from '../../utils/helpers/features-routes-helpers';
import { Redirect, useParams } from 'react-router';
import React from 'react';
import { PodiumFeatures } from '../../constans/common-constants';
import { IRouteParams } from '../../pages/container/container';
import Loader from '../shared/loader/loader';

const BlankPage = (): JSX.Element => {
  const { permissionsStore } = useStore();
  const { isLoading } = permissionsStore;
  const defaultPath = getDefaultRouteRedirectPath(permissionsStore);
  const { BLANK } = PodiumFeatures;
  const { id } = useParams<IRouteParams>();

  if (defaultPath !== BLANK.path) {
    return <Redirect to={`/presentation/${id}${defaultPath}`}/>;
  }

  return (
    <div className='blank-page'>
      {isLoading
        ? <Loader/>
        : <p className='blank-page-message'>There are no Podium features enabled.</p>
      }
    </div>
  );
};

export default observer(BlankPage);